<template>
  <div id="app">
    <div>
      <NetworkStatus/>
    </div>
    <Loader/>
    <router-view/>
    <div v-if="showSmallAnnouncement" class="announcement-bar">
      <div class="announcement-content">
        <div class="announcement-title">{{ smallAnnouncement.title }}</div>
        <div class="announcement-message">{{ smallAnnouncement.message }}</div>
      </div>
      <div class="announcement-actions">
        <a
            v-if="smallAnnouncement.ctaUrl"
            class="btn btn-light btn-sm"
            :href="smallAnnouncement.ctaUrl"
            target="_blank"
            rel="noopener"
        >
          {{ smallAnnouncement.ctaLabel || 'Learn More' }}
        </a>
        <button class="btn btn-outline-light btn-sm" @click="dismissSmallAnnouncement">Close</button>
      </div>
    </div>
    <div v-if="showLargeAnnouncement" class="announcement-modal-backdrop">
      <div class="announcement-modal">
        <button class="announcement-modal-close" @click="dismissLargeAnnouncement" aria-label="Close">
          &times;
        </button>
        <div class="announcement-modal-header">
          <div class="announcement-modal-badge">Notice</div>
          <h2 class="announcement-modal-title">{{ largeAnnouncement.title }}</h2>
        </div>
        <div class="announcement-modal-body">
          <p>{{ largeAnnouncement.message }}</p>
        </div>
        <div class="announcement-modal-actions">
          <a
              v-if="largeAnnouncement.ctaUrl"
              class="btn btn-outline-primary"
              :href="largeAnnouncement.ctaUrl"
              target="_blank"
              rel="noopener"
          >
            {{ largeAnnouncement.ctaLabel || 'Learn More' }}
          </a>
          <button class="btn btn-primary" @click="dismissLargeAnnouncement">
            {{ largeAnnouncement.ctaLabel || 'OK' }}
          </button>
        </div>
      </div>
    </div>
    <custom-modal ref="update" title="Please Update" size="fullscreen">
<!--      <div class="box-container mt-2">-->
<!--        <div class="box red-background-blink">-->
<!--          <h6 class="route-btn w-100 bg-transparent text-white"> <h3 class="card-title">You have <strong>{{ days }} days {{ hours }} hours {{ minutes }} minutes {{ seconds }} seconds</strong> before you get logged out.</h3> </h6>-->
<!--        </div>-->
<!--      </div>-->
      <div id="carouselExampleSlidesOnly" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner">
          <div
              v-for="(step, index) in steps"
              :key="index"
              class="carousel-item"
              :class="{ active: index === 0 }"
          >
            <img :src="step.image" class="img d-block w-100" :alt="'Slide ' + (index + 1)"/>
            <div class="carousel-caption d-none d-md-block"></div>
          </div>
        </div>
        <button
            class="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleSlidesOnly"
            data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon" style="background-color: #1c1c1c" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button
            class="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleSlidesOnly"
            data-bs-slide="next"
        >
          <span class="carousel-control-next-icon" style="background-color: #1c1c1c" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </custom-modal>
  </div>
</template>

<script>
import {EventBus} from "@/utils/event-bus";
import Loader from "@/components/layout/Loader";
import NetworkStatus from "@/components/layout/NetworkStatus.vue";
import CustomModal from "@/components/layout/utils/CustomModal.vue";
import {Storage} from "@/services/Storage";

export default {
  components: {CustomModal, NetworkStatus, Loader},
  async beforeMount() {
    if (!this.$store.getters.isHydrated) {
      await new Promise((resolve) => {
        const interval = setInterval(() => {
          if (this.$store.getters.isHydrated) {
            clearInterval(interval);
            resolve();
          }
        }, 50);  // Check every 50ms
      });
    }
    const defaultStore = await Storage.getDefaultStore();
    if (defaultStore) {
      this.$store.dispatch('syncData');
    }
  },
  computed: {
    loading() {
      return this.$store.getters.getLoadingState;
    },
    isSmartInvoiced() {
      return this.$store.getters.getSmartInvoicingStatus;
    },
    curUser() {
      return this.$store.getters.getCurrentUser
    },
    smallAnnouncement() {
      return this.announcements?.small || {};
    },
    largeAnnouncement() {
      return this.announcements?.large || {};
    },
    showSmallAnnouncement() {
      const ann = this.smallAnnouncement;
      if (!ann || !ann.enabled) return false;
      return !this.dismissedAnnouncements?.[ann.id];
    },
    showLargeAnnouncement() {
      const ann = this.largeAnnouncement;
      if (!ann || !ann.enabled) return false;
      return !this.dismissedAnnouncements?.[ann.id];
    }
  },
  mounted() {
    this.updateApp();
  },
  data() {
    return {
      timeLeft: 0, // Total time left in milliseconds
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      timer: null,
      name: this.$route.name,
      announcements: window.ANNOUNCEMENTS || {},
      dismissedAnnouncements: {},
      steps: [
        {image: require('@/assets/img/update/1st.png')},
        {image: require('@/assets/img/update/step2.png')},
        {image: require('@/assets/img/update/step3.png')},
        {image: require('@/assets/img/update/step4.png')},
        {image: require('@/assets/img/update/step5.png')},
        {image: require('@/assets/img/update/step6.png')},
        {image: require('@/assets/img/update/step7.png')},
        {image: require('@/assets/img/update/step8.png')},
        {image: require('@/assets/img/update/last.png')}
      ]
    };
  },
  methods: {
    loadDismissedAnnouncements() {
      this.dismissedAnnouncements = {};
    },
    dismissSmallAnnouncement() {
      const id = this.announcements?.small?.id;
      if (id) {
        this.$set(this.dismissedAnnouncements, id, true);
      }
    },
    dismissLargeAnnouncement() {
      const id = this.announcements?.large?.id;
      if (id) {
        this.$set(this.dismissedAnnouncements, id, true);
      }
    },
    updateCountdown() {
      // Get current date
      const now = new Date();

      // Get next Sunday (the next 00:00:00 on Sunday)
      const nextSunday = new Date(now);
      nextSunday.setDate(now.getDate() + (8 - now.getDay())); // Set to next Sunday
      nextSunday.setHours(0, 0, 0, 0); // Set time to midnight

      // Calculate the time difference
      this.timeLeft = nextSunday - now;

      // If timeLeft is less than or equal to 0, stop the countdown
      if (this.timeLeft <= 0) {
        clearInterval(this.timer); // Stop the countdown
        return;
      }

      // Calculate days, hours, minutes, and seconds
      this.days = Math.floor(this.timeLeft / (1000 * 60 * 60 * 24));
      this.hours = Math.floor((this.timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minutes = Math.floor((this.timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((this.timeLeft % (1000 * 60)) / 1000);
    },

    startCountdown() {
      this.updateCountdown();

      this.timer = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    },

    async updateApp() {
      return this.$store.dispatch("checkSmartInvoicing")
          .then(async () => {
            if (this.isSmartInvoiced) {
              let showPopup = false;
              try {
                let isSmartInvoice = Printing.smartInvoice();
                showPopup = !!isSmartInvoice;
              } catch (e) {
                // showPopup = true
              }
              // if (showPopup) {
              //   this.$refs.update.openModal();
              //   // let user = await this.curUser;
              //   // if (user) {
              //   //   if (user.Username === 'Admin') {
              //   //     user = localStorage.getItem("supportAgent");
              //   //     localStorage.removeItem(`supportAgent`);
              //   //   }
              //   //   await this.$store.dispatch(`recordLogout`, user.Username)
              //   //   await this.$router.push({name: 'poslogin'})
              //   // }
              // }
            }
          });
    }
  },
  created() {
    EventBus.$on('user-logged-in', this.updateApp);
    this.startCountdown();
    this.loadDismissedAnnouncements();
  },
  beforeDestroy() {
    EventBus.$off('user-logged-in', this.updateApp);
    clearInterval(this.timer);
  }
};
</script>

<style lang="scss">
@import "assets/css/styles";

.carousel-item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel-inner {
  width: 100%;
}

.carousel-caption {
  position: absolute;
  bottom: 20px;
  left: 20px;
  right: 20px;
  text-align: left;
}

.img {
  height: 50vh;
  object-fit: contain;
}

.box-container {
  display: flex;
  justify-content: center; /* Center contents horizontally */
  margin-bottom: 10px; /* Adjust as needed */
}

.red-background-blink {
  background-color: red;
  animation: blink 1s infinite;
  padding: 10px 20px; /* Adjust height and width */
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.announcement-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1050;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: linear-gradient(90deg, #0f172a 0%, #1e293b 100%);
  color: #fff;
  box-shadow: 0 -6px 20px rgba(0, 0, 0, 0.2);
}

.announcement-content {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.announcement-title {
  font-weight: 700;
  letter-spacing: 0.2px;
}

.announcement-message {
  opacity: 0.9;
}

.announcement-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.announcement-modal-body p {
  margin-bottom: 16px;
}

.announcement-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.65);
  padding: 24px;
}

.announcement-modal {
  position: relative;
  width: min(720px, 92vw);
  background: #fff;
  border-radius: 18px;
  padding: 28px 28px 24px;
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.25);
  border: 1px solid rgba(15, 23, 42, 0.08);
}

.announcement-modal-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: #f1f5f9;
  color: #0f172a;
  font-size: 24px;
  line-height: 1;
}

.announcement-modal-header {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 14px;
}

.announcement-modal-badge {
  align-self: flex-start;
  background: #0f172a;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  padding: 6px 10px;
  border-radius: 999px;
}

.announcement-modal-title {
  margin: 0;
  font-size: 24px;
  line-height: 1.2;
  color: #0f172a;
}

.announcement-modal-body {
  color: #334155;
  font-size: 16px;
}

.announcement-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

@media (max-width: 480px) {
  .announcement-modal {
    padding: 22px 18px 18px;
  }

  .announcement-modal-title {
    font-size: 20px;
  }

  .announcement-modal-actions {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
